export enum PMProjectStatusEnum {
    decidingLaunch = 1, // Принимается решение о запуске
    designStarted, // Запущено проектирование
    constructionUnderway, // Ведется строительство
    workStopped, // Работы остановлены
    completed, // Завершен
}

export enum PMChartStatusEnum {
    planned = 1, // Запланирован
    approved, // Утвержден
    stopped, // Остановлен
    completed, // Завершен
    cancelled, // Аннулирован
}

export enum PMChartBpcStatusEnum {
    prepared = 1, // подготовлен
    onApproval, // на согласовании
    agreed, // согласован
    notAgreed, // не согласован
}

export enum WeeklyReportEnum {
    CompiledBySupervisor = 1, // Недельный отчет составлен тех.надзором
    OnApprovalByPM, // На согласовании у руководителя проекта
    OnApprovalByCS, // На согласовании у регионального руководителя по строительству
    Agreed, // Недельный отчет согласован
}

export enum PMTableActionEnum {
    open,
    openStructure,
    history,
}

export enum PMDocumentTypeEnum {
    project = 1,
    chart,
}

export enum PMDocumentPropertyEnum {
    project,
    chart,
    bpc,
}

export enum PMPlanChartEnum {
    version = 'chart-versions',
    dpcQuart = 'detailed-schedule',
    dpcExec = 'detailed-schedule-execution',
    weekly = 'weekly-schedule',
}

export enum PMTabTypeEnum {
    chartInfo = 1, // Информация о графике
    structure, // Структура
    bpc, // БПГ
    dpcQuart, // Квартальный ДПГ
    dpcExec, // Исполнение ДПГ
    weeklyReport, // Недельный отчет
    bpcPage,
    version,
}

export enum PMChartTypeEnum {
    consolidated = 1, // Сводный
    design, // Проектирование
    construction, // Строительство
    tenders, // Тендеры
}

export enum PMCalendarTypeEnum {
    fiveDays = 5,
    sevenDays = 7,
}

export enum PMReportTypeEnum {
    bpc,
    dpcExec,
    dpcQuart,
    weeklyReport,
}

export enum PMChartVersionTypeEnum {
    current = 1,
    approved,
    other,
}

export enum PMTableRowCellType {
    date,
    user,
    status,
    checkbox,
    bool,
}

export enum PMChartModalActionEnum {
    Form,
    SendForApproval,
}

export enum PMChartVersionApprovalStatusEnum {
    none = 1, // 1 - не началось (Не согласован)
    onApproval, // 2 - началось (На согласовании)
    approved, // 3 - согласовано
}

export enum PMChartPageModeEnum {
    creation = 'creation',
    show = 'show',
}

export enum PMTaskTypeEnum {
    project = 1, // Проектная задача
    stage, // Группа работ
    milestone, // Веха
    tenders, // Тендеры
}

export enum PMStructureTypeEnum {
    Task = 1,
    Stage,
    Mark,
}

export enum CreateTaskActions {
    CreateTaskUpper,
    CreateTaskLower,
    CreateTaskInner,
}

export enum CreateVersionActions {
    Bpc,
    Version,
}

export enum TogglerGanttTable {
    Table = 1,
    Gantt,
}

export enum HeaderTabsEnum {
    Settings = 1, // Настройки
    Connections, // Связи и старт
    History, // История
}

export enum PMStructureModeEnum {
    Manually = 1,
    Automatically,
}

export enum PMStructureLinkLocationEnum {
    ThisChart = 1,
    OtherChart,
}

export enum PMStructureTemplateTypeEnum {
    Template = 1,
    Folder,
}

export enum PMStructureGanttScaleTypeEnum {
    Days,
    Weeks,
    Months,
    Quarters,
}

export enum PMApprovalTypeEnum {
    Default = 1,
    Deadlines,
    WorkDocumentation,
}
